import React,{ useEffect,useState }  from 'react'
import Style from './Chat.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faUserCircle } from '@fortawesome/free-solid-svg-icons'
import { AnswerApi, chatMessageApi } from '../../API/AdminServices'
import { ThreeHorseLoading } from 'react-loadingg'
import { errorToast, succToast } from '../../Toast/Toast'
import Modal from '../../Components/Modal/Modal';

const Chat = (props) => {
    const[answerText,setAnswerText]=useState('')
    const[commentID,setCommentId]=useState()
    useEffect(()=>{
        getChatList()
    },[])
    const [chatMessage,setChatMessage]=useState()
    const getChatList=async()=>{
        const data=await chatMessageApi(props.location.pathname.split('/')[2])
        setChatMessage(data.comment)
    }

    const[purchased,setPurchased]=useState(false)

    const closeModalHandler=()=>{
        setPurchased(false)
    }
    const showAnswerTextArea=(id)=>{
        setCommentId(id)
        setPurchased(true)
    }
    let loadingHandler=null
    if(chatMessage===undefined){
        loadingHandler=<ThreeHorseLoading/>
    }
    else{
        loadingHandler=chatMessage.map((item,index)=>{
                return(
                    <ul key={index} className={Style.ChatContent}>
                    {
                        item.comment===null?null:
                        <li className={Style.ChatQuestion}>
                            <h4>
                            {item.comment}
                                <div className={Style.ReplyButtonHolder}>
                                    <p>{item.date}</p>
                                    <label onClick={()=>showAnswerTextArea(item.id)}>پاسخ</label>
                                </div>
                            </h4>
                        
                        </li>
                    }
                    {item.cr_comment===null?null:
                    <li className={Style.ChatAnswer}>
                        <h4>
                            {item.cr_comment}
                            
                            <p>{item.cr_date}</p>
                        </h4>
                    </li>
                }
                </ul>
                )
            })
        
    }
    const AnswerHanlder=()=>{
        if(answerText===''){
            errorToast("لطفا پاسخ خودرابنویسید")
        }
        else{
            let info={
                id:commentID,
                comment:answerText
            }
            AnswerApi(info,(succ)=>{
                if(succ.status===1){
                    succToast(succ.message)
                    setAnswerText('')
                    getChatList()
                    setPurchased(false)
                }
                else{
                    errorToast(succ.message)
                }
            })
        }
    }
    return (
        <div className={Style.PageHolder}>
            <Modal show={purchased} modalClose={closeModalHandler} translate={30}>
                <div className={Style.chatReply}>
                    <textarea placeholder='جواب خودرا وارد کنید...' value={answerText} onChange={e=>setAnswerText(e.target.value)}/>
                    <p onClick={AnswerHanlder}>پاسخ</p>
                </div>
            </Modal>
            <div className={Style.ImageHolder}><img src="/Assets/Images/Comment/comment2.svg" alt="electronicSteps" /></div>

            <section className={Style.ChatSection}>
                <div className={Style.ChatHeader}>
                    <FontAwesomeIcon icon={faUserCircle}/>
                    <p>{props.location.state}</p>
                </div>
                {
                    loadingHandler
                }
                

            </section>
        </div>
    )
}

export default Chat
